import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  forwardRef,
  AfterViewChecked,
} from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  GoldenLayoutComponent,
  GoldenLayoutServiceProfileConfig,
} from "../golden-layout/golden-layout-component";
import { BfxConnectionMonitorAuditComponent } from "./bfx-connection-monitor-audit.component";
import { BfxConnectionMonitorConnectionsComponent } from "./bfx-connection-monitor-connections.component";
import { BfxConnectionMonitorService } from "./bfx-connection-monitor.service";

@Component({
  selector: "bfx-connection-monitor",
  templateUrl: "./html/bfx-connection-monitor.html",
  standalone: false,
})
export class BfxConnectionMonitorComponent implements GoldenLayoutComponent {
  public selectedTab: number = 0;

  @ViewChild("connections", { static: true })
  public componentConnections: BfxConnectionMonitorConnectionsComponent;

  @ViewChild("audit", { static: true })
  public componentAudit: BfxConnectionMonitorAuditComponent;

  constructor(private componentService: BfxConnectionMonitorService) {}

  public onTabSelected(event: any) {
    this.selectedTab = event.index;
  }

  public resize() {}

  getComponentConfiguration(): any {
    let serviceConfig: any = { config: { selectedTab: this.selectedTab } };

    if (this.componentConnections != null && this.componentAudit != null) {
      serviceConfig.connections = this.componentConnections.getComponentConfiguration();
      serviceConfig.audit = this.componentAudit.getComponentConfiguration();
    }

    return serviceConfig;
  }

  restoreFromConfiguration(config: any): void {
    let serviceConfig: any = config;

    if (serviceConfig != null) {
      if (serviceConfig.config != null && serviceConfig.config.selectedTab != null) {
        this.selectedTab = serviceConfig.config.selectedTab;
      }

      if (serviceConfig.connections != null && this.componentConnections != null) {
        this.componentConnections.restoreFromConfiguration(serviceConfig.connections);
      }

      if (serviceConfig.audit != null && this.componentAudit != null) {
        this.componentAudit.restoreFromConfiguration(serviceConfig.audit);
      }
    }
  }
}
